// src/components/atoms/Card.ts
import styled, { css } from "styled-components";

/**
 * Shared "flat & app-like" card surface (subtle border + rounded corners +
 * soft shadow) — the same look as the question card. Drop `${cardSurface}`
 * into any styled card so they share one source of truth: improve it here and
 * every card that uses it updates together.
 */
export const cardSurface = css`
  border: 1px solid #ececec;
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
`;

type CardProps = {
  $margin?: string;   // transient prop (won't be forwarded to DOM)
  $padding?: string;
};

const Card = styled.div<CardProps>`
  background: white;
  margin: ${({ $margin }) => $margin ?? "30px 20px"};
  padding: ${({ $padding }) => $padding ?? "5px 10px"};
  border-radius: 22px;
  box-shadow: 2px 2px 4px 4px rgba(0, 0, 0, 0.1);
`;

export default Card;
